export const USAGE_STATISTICS_UPDATED = 'usageStatistics/updated';
export const USAGE_STATISTICS_IN_PROGRESS = 'usageStatistics/inProgress';
